import { createContext, useContext } from 'react';
import { ContentObject } from '@/interface';

export interface ContextType {
  content: ContentObject;
}

type ContentProviderProps = {
  children: React.ReactNode;
  content: ContentObject;
};

const ContentContext = createContext<ContextType | undefined>(undefined);

export const ContentProvider: React.FC<ContentProviderProps> = ({ children, content }) => {
  return <ContentContext.Provider value={{ content }}>{children}</ContentContext.Provider>;
};

export const useContent = (): ContextType => {
  const context = useContext(ContentContext);

  if (!context) {
    throw new Error('useContent must be used within a ContentProvider');
  }

  return context;
};
